// extracted by mini-css-extract-plugin
module.exports = {"page":"BlogAuthorPage_page__fHINT","profile-image":"BlogAuthorPage_profile-image__X2Q_2","bio":"BlogAuthorPage_bio__DKMry"};